module.exports = __webpack_public_path__ + "img/ccompany-honor-COC-20230718.487aaafe.jpg";